import React, { useState } from "react";
import CustomerDetails from "./CustomerDetails/CustomerDetails";
import CustomerAddress from "./CustomerDetails/CustomerAddress";


const CustomerBanner = ({
  coverImageUrl,
  profileImageUrl,
  name,
  role,
  location,
  progress,
}) => {
  const [activeTab, setActiveTab] = useState("profile"); // State for active section

  return (
    <>
      <div className="bg-gray-100 overflow-hidden shadow rounded-2xl text-sm"> {/* Added text-sm */}
        {/* Cover Section */}
       
        {/* Profile Details Section */}
        <div className="relative px-5 py-2 bg-white h-[100px]"> {/* Reduced padding with height 100px */}
          {/* Profile Image */}
          <div className="absolute -top-5 left-2"> {/* Adjusted position */}
            <img
              src={profileImageUrl}
              alt="Profile"
              className="w-20 h-20 rounded-full border-2 border-white shadow-lg mt-[28px]" // Smaller image with margin top 28px
            />
             <div 
                  className="absolute bottom-12 -right-2  bg-white rounded-full p-1 shadow-lg cursor-pointer"
                  onClick={() => document.getElementById('profile-image-input').click()}
                >
                  <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    className="h-4 w-4 text-gray-600" 
                    fill="none" 
                    viewBox="0 0 24 24" 
                    stroke="currentColor"
                  >
                    <path 
                      strokeLinecap="round" 
                      strokeLinejoin="round" 
                      strokeWidth={2} 
                      d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" 
                    />
                  </svg>
                </div>
                <input
                  type="file"
                  id="profile-image-input"
                  className="hidden"
                  accept="image/*"
                  onChange={(e) => {
                    if (e.target.files && e.target.files[0]) {
                      // Handle file upload here
                      const file = e.target.files[0];
                      // You'll need to implement the upload and save functionality
                      // Example: updateProfileImage(file)
                    }
                  }}
                />
          </div>

          {/* User Info */}
          <div className="ml-24 pt-0"> {/* Adjusted margin */}
            <h2 className="text-base font-semibold">{name}</h2> {/* Smaller text */}
            <p className="text-gray-600 flex items-center space-x-2 text-sm"> {/* Smaller text */}
              <span>{role}</span>
              {/* <span>•</span> */}
              <span>{location}</span>
            </p>

            {/* Progress Bar */}
            <div className="mt-2">
              <div className="h-1.5 bg-gray-200 rounded-full w-32"> {/* Smaller bar */}
                <div
                  className="h-full bg-blue-500 rounded-full"
                  style={{ width: `${progress}%` }}
                ></div>
              </div>
              <p className="text-xs text-gray-500 mt-1">{progress}%</p> {/* Smaller text */}
            </div>
          </div>
        </div>

        {/* Navigation Links */}
        <div className="relative bg-white pt-2"> {/* Reduced padding */}
          <ul className="flex justify-start gap-6 text-gray-600 w-full px-4 text-sm"> {/* Smaller gap and text */}
            <li
              className={`cursor-pointer px-4 py-2 h-full ${
                activeTab === "profile" ? "bg-gray-300" : "hover:bg-[#E0E0E0]"
              }`}
              style={{ borderRadius: "10px 10px 0 0" }}
              onClick={() => setActiveTab("profile")}
            >
              Profile
            </li>
            <li
              className={`cursor-pointer px-4 py-2 h-full ${
                activeTab === "address" ? "bg-gray-300" : "hover:bg-[#E0E0E0]"
              }`}
              style={{ borderRadius: "10px 10px 0 0" }}
              onClick={() => setActiveTab("address")}
            >
              Address
            </li>
          </ul>
        </div>
      </div>

      {/* Dynamic Section - Placed Outside with Gap */}
      <div className="mt-4 p-4 bg-white shadow-md rounded-2xl text-sm"> {/* Smaller padding and text */}
        {activeTab === "profile" && <CustomerDetails />}
        {activeTab === "address" && <CustomerAddress />}
      </div>
    </>
  );
};

export default CustomerBanner;